export default "__VITE_ASSET__C1$$LXC7__"